import BaseObject, { BaseObjectParams } from '../baseObject';
import Sprite, { SpriteParams } from './sprite';

export interface BackgroundSpriteParams extends SpriteParams {
  background?: Background;
}

export class BackgroundSprite extends Sprite implements BackgroundSpriteParams {
  background!: Background;

  temporaryContext!: CanvasRenderingContext2D;

  constructor(params: BackgroundSpriteParams) {
    super(params);
    this.applyParams(params);
    if (this.src) {
      this.image.onload = () => {
        const { width, height } = this;
        const temporaryCanvas = document.createElement('canvas');
        temporaryCanvas.width = width;
        temporaryCanvas.height = height;
        const context = temporaryCanvas.getContext('2d');
        if (context) {
          this.temporaryContext = context;
          this.temporaryContext.drawImage(this.image, 0, 0, width, height);
        }
      };
    }
  }

  /* background sprites are drawn from the top-left corner, not the middle like the generic Sprite object */
  draw(): CanvasRenderingContext2D {
    const { context: ctx, x, y, maxX, maxY } = this.background;
    const {
      image,
      width,
      height,
    } = this;

    if (this.background.loop && this.temporaryContext) {
      ctx.save();
      const pattern = ctx.createPattern(this.temporaryContext.canvas, 'repeat');
      if (pattern) {
        ctx.fillStyle = pattern;
        ctx.fillRect(x, x, maxX, maxY);
      }
      ctx.restore();
    }
    else {
      ctx.drawImage(
        image,
        x,
        y,
        width,
        height,
      );
    }

    return ctx;
  }
}

export interface BackgroundParams extends BaseObjectParams {
  context: CanvasRenderingContext2D;
  spriteParams: SpriteParams;
  x: number;
  y: number;
  maxX?: number;
  maxY?: number;
  loop?: boolean;

}

export default class Background extends BaseObject implements BackgroundParams {
  context!: CanvasRenderingContext2D;
  spriteParams!: SpriteParams;
  x: number = 0;
  y: number = 0;
  maxX!: number;
  maxY!: number;
  loop = false;

  sprite: BackgroundSprite;

  constructor(params: BackgroundParams) {
    super();
    this.applyParams(params);

    // this.scene.backgrounds = [...this.scene.backgrounds, this];
    this.sprite = new BackgroundSprite({ ... this.spriteParams, background: this as Background } as BackgroundSpriteParams);
  }

  draw(): CanvasRenderingContext2D {
    return this.sprite.draw();
  }
}
